import { useBookingModuleStoreActions } from "PFApp/booking/store";
import { useCallback } from "react";

import { getBookingDatesDiff } from "./drag_calculations";
import { useIsAuditBooking } from "./use_is_audit_booking";

export type DragAxes = {
  horizontal: boolean;
  vertical: boolean;
};

const NO_AXES: DragAxes = { horizontal: false, vertical: false };

export const useDragAxes = () => {
  const { getBookingData, getBookingDragAndDropData } = useBookingModuleStoreActions();
  const isAuditBooking = useIsAuditBooking();

  const getDragAxes = useCallback((): DragAxes => {
    const { bookingId, draggingStartDate, draggingEndDate, targetRow } = getBookingDragAndDropData();
    const booking = bookingId ? getBookingData(bookingId)?.booking : undefined;
    if (!booking) {
      return NO_AXES;
    }

    if (!isAuditBooking(booking)) {
      return { horizontal: true, vertical: true };
    }

    const hasChangedDates =
      !!draggingStartDate &&
      !!draggingEndDate &&
      getBookingDatesDiff(booking, draggingStartDate, draggingEndDate) !== 0;

    return { horizontal: !targetRow, vertical: !hasChangedDates };
  }, [getBookingData, getBookingDragAndDropData, isAuditBooking]);

  return { getDragAxes };
};
